var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21.0038093px",
    height: "21px",
    viewBox: "0 0 21.0038093 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "carbon:cloud-offline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NCOB-Settings-Quick",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CC-OB-General-On-Setup",
    transform: "translate(-326.4993, -1649.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carbon:cloud-offline",
    transform: "translate(325, 1648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6,9.102 C18.4549477,8.43222588 18.2072758,7.78888605 17.86575,7.19475 L22.5,2.5605 L21.44025,1.5 L1.5,21.44025 L2.5605,22.5 L6.3105,18.75 L17.625,18.75 C20.1283912,18.7526339 22.2264802,16.8578905 22.478184,14.3671839 C22.7298879,11.8764772 21.053303,9.60027585 18.6,9.102 L18.6,9.102 Z M17.625,17.2500182 L7.8105,17.2500182 L16.7565,8.304 C16.9869099,8.7949916 17.1387608,9.31913024 17.2065,9.85725 L17.28075,10.46625 L17.892,10.51425 C19.7017587,10.6520312 21.0779575,12.1972844 21.0060689,14.0108562 C20.9341803,15.8244279 19.4399864,17.2559009 17.625,17.2500182 L17.625,17.2500182 Z M3.222,17.58675 L4.296,16.5135 C3.19957901,15.6609868 2.74116725,14.2214334 3.14273662,12.8918997 C3.54430599,11.562366 4.72297137,10.6172718 6.108,10.51425 L6.72,10.46625 L6.79425,9.85725 C7.01064456,8.08003575 8.11938824,6.53629028 9.73439173,5.76358024 C11.3493952,4.9908702 13.2471253,5.09614665 14.76675,6.04275 L15.849,4.9605 C13.9939291,3.66744504 11.6140244,3.39088347 9.51186811,4.22408095 C7.40971178,5.05727843 5.86550312,6.88917689 5.4,9.102 C3.5717509,9.47260286 2.11611931,10.8554814 1.65234598,12.6623449 C1.18857265,14.4692084 1.79824418,16.3821948 3.222,17.5875 L3.222,17.58675 Z",
    id: "Shape",
    fill: "#979797",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/Offline.cb68f772b3bb092eec20e6782012ad81.svg";
export { ForwardRef as ReactComponent };